export const FloatTabs: Record<string, string> = {
  loanDetail: 'Loan Details',
  notification: 'Notification',
  underwriting: 'Underwriting',
  documents: 'Documents',
  notes: 'Notes',
}

export const pageUrls: Record<string, any> = {
  loanOverview: { title: 'Loan Overview', url: '/loan_process/overview' },
  loanStructure: { title: 'Loan Structure', url: '/loan_process/structure' },
  loanApplication: { title: 'Loan Application', url: '/loan_process/application' },
  loanSubmission: { title: 'Loan Submission', url: '/loan_process/submit' },
  orderValuation: { title: 'Order Valuation', url: '/order_valuation' },
  documentsGenie: { title: 'DocumentsGenie', url: '/document_genie' },
  notes: { title: 'Notes', url: '/notes' },
  closingCalendar: { title: 'Closing Calendar', url: '/closing_calendar' },
  loanIntake: { title: 'Loan Intake', url: '/loanInTake' },
  seconadryMarketing: { title: 'Secondary Marketing', url: '/secondary_marketing_screen' },
  underwriting: { title: 'Underwriting', url: '/underwriting' },
  closingScreen: { title: 'Closing Screen', url: '/closing_screen' },
  postClosing: { title: 'Post Closing', url: '/post_closing' },
  servicing: { title: 'Servicing', url: '/servicing' },
  funding: { title: 'Funding', url: '/funding' },
  amortizationSchedule: { title: 'Amortization Schedule', url: '/amortization_schedule' },
  invoice: { title: 'Invoice', url: '/invoice' },
  feeWorksheet: { title: 'Fee Worksheet', url: '/fee_worksheet' },
  fci: { title: 'FCI', url: '/fci' },
  parties: { title: 'Parties', url: '/parties' },
}
